import { Item } from '../Rest/Services/Data';
import { SaveItemRequest } from "../Rest/Services/CartService/CartsService";

// Об’єднує два масиви Item (один з бекенду, інший з localStorage)
// Якщо товар зустрічається в обох, вибирається той, у якого count більше.
// removedIds — товари, які користувач явно прибрав з кошика локально (як гість);
// вони виключаються з результату, навіть якщо все ще присутні в backendCart,
// інакше видалений товар "воскресає" після повторного логіну.
export const mergeCarts = (
  backendCart: Item[],
  localCart: Item[],
  removedIds: ReadonlySet<number> = new Set()
): SaveItemRequest[] => {
  const mergedMap = new Map<number, number>();

  // Додаємо товари з бекенду (ключ – item.id, значення – count)
  backendCart.forEach(item => {
    if (!removedIds.has(item.id)) {
      mergedMap.set(item.id, item.count);
    }
  });

  // Для кожного товару з localCart:
  localCart.forEach(item => {
    if (mergedMap.has(item.id)) {
      const currentCount = mergedMap.get(item.id)!;
      mergedMap.set(item.id, Math.max(currentCount, item.count));
    } else {
      mergedMap.set(item.id, item.count);
    }
  });

  return Array.from(mergedMap.entries()).map(([itemId, count]) => ({
    itemId,
    count,
  }));
};
